import { HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CrudService } from "src/app/components/shared/cruds/crud.service";
import { ListasRecepciones } from "src/app/models/dto/combo-display.dto";
import { TrabajadorSimpleDTO } from "src/app/models/dto/trabajador-simple.dto";
import { TrabajadorDTO } from "src/app/models/dto/trabajador.dto";
import { BajaTrabajadorForm } from "src/app/models/forms/baja-trabajador.form";
import { TrabajadorForm } from "src/app/models/forms/trabajador.form";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class OperadoresService extends CrudService<TrabajadorDTO> {
  protected controller: string = "settings/trabajador/";

  public addWithFile(defa: TrabajadorForm, imagen: File): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    const formData = new FormData();
    Object.keys(defa).forEach((v) => formData.append(v, defa[v]));

    if (imagen) {
      formData.append("Imagen", imagen, "Imagen");
    }
    return this.http.post<any>(
      `${environment.serverUrl}api/${this.controller}/addWithImage`,
      formData
    );
  }

  public updateWithFile(defa: TrabajadorForm, imagen: File): Observable<any> {
    const formData = new FormData();
    Object.keys(defa).forEach((v) => formData.append(v, defa[v]));

    if (imagen) {
      formData.append("Imagen", imagen, "Imagen");
    }
    return this.http.post<any>(
      `${environment.serverUrl}api/${this.controller}/updateWithImage`,
      formData
    );
  }
  public image(i: string): Observable<string> {
    return this.http.get<string>(
      `${environment.serverUrl}api/${this.controller}image`,
      { params: { i } }
    );
  }

  public darDeBaja(row: BajaTrabajadorForm): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/${this.controller}darDeBaja`,
      row,
      options
    );
  }
  public getPdf(i: string): Observable<HttpResponse<Blob>> {
    return this.http.get(
      `${environment.serverUrl}api/${this.controller}actaSeguro`,
      { params: { i }, responseType: "blob", observe: "response" }
    );
  }

  public getPdfBaja(i: string): Observable<HttpResponse<Blob>> {
    return this.http.get(
      `${environment.serverUrl}api/${this.controller}actaSeguroBaja`,
      { params: { i }, responseType: "blob", observe: "response" }
    );
  }

  public getBajas(): Observable<TrabajadorSimpleDTO[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/${this.controller}getBajas`
    );
  }

  public getNoReingreso(): Observable<TrabajadorSimpleDTO[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/${this.controller}getNoReingreso`
    );
  }

  public getListas(): Observable<ListasRecepciones> {
    return this.http.get<ListasRecepciones>(
      `${environment.serverUrl}api/${this.controller}getBoth`
    );
  }

  public getHistorialLog(i: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/${this.controller}getHistorialLog`,
      { params: { i } }
    );
  }

  public getHistorialAssigns(i: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/${this.controller}getHistorialAssigns`,
      { params: { i } }
    );
  }
}
